import { Grid, Typography } from "@mui/material";
import BodyPanel from "shared/components/panel/BodyPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import { Panel } from "shared/components/panel/Panel";
import CampoBusca from "./components/CampoBusca";
import GestaoAssinaturaDashboard from "./components/GestaoAssinaturaDashboard";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import RenderRowGestaoAssinatura from "./components/RenderRowGestaoAssinatura";
import { useGestaoAssinaturaLogic } from "./hooks/useGestaoAssinaturaLogic";
import { TipoStatusAssinaturaDigital } from "types/dto/groupsign/TipoStatusAssinaturaDigital";

const columns: TableColumn[] = [
  { id: "condominio", label: "Condomínio", width: "30%", textAlign: "center", isOrdenavel: true },
  { id: "documento", label: "Documento", width: "30%", textAlign: "center" },
  { id: "status", label: "Status", width: "20%", textAlign: "center" },
];

export const GestaoAssinatura: React.FC = () => {
  const {
    statusAtivacao,
    ordenarPorColuna,
    ordenacaoAscOuDesc,
    paginaAtual,
    data,
    totalPages,
    totalElements,
    totalPendentes,
    totalAssinados,
    totalRecusados,
    totalCancelados,
    isLoading,
    refetch,
    handleSort,
    titulo,
    setBuscarCondominio,
    setStatusAtivacao,
    setPaginaAtual,
    setDataInicio,
    setDataFim,
  } = useGestaoAssinaturaLogic();

  return (
    <Panel headerPanel={<HeaderPanel title="Gestão de assinaturas" ocultarCondominio abaAtual="Assinatura digital" />}>
      <BodyPanel>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Gerencie aqui as assinaturas digitais dos condomínios de forma rápida e segura.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <CampoBusca
              onSearchChange={setBuscarCondominio}
              onStatusChange={(status: string) => setStatusAtivacao(status as TipoStatusAssinaturaDigital)}
              onDateRangeChange={(inicio, fim) => {
                setDataInicio(inicio);
                setDataFim(fim);
              }}
              status={statusAtivacao}
            />
          </Grid>
          <Grid item xs={12}>
            <GestaoAssinaturaDashboard
              valueTotal={totalElements}
              labelTotal="Total de documentos"
              valuePending={totalPendentes}
              labelPending="Pendentes assinatura"
              valueSigned={totalAssinados}
              labelSigned="Documentos assinados"
              valueRefused={totalRecusados}
              labelRefused="Documentos recusados"
              title={titulo}
              canceledDocuments={totalCancelados}
            />
          </Grid>
          <Grid item xs={12}>
            <Tabela
              id="gestao-assinatura"
              colunas={columns}
              ordernarPorColuna={ordenarPorColuna}
              ordenacaoAscOuDesc={ordenacaoAscOuDesc}
              ordenarRegistrosFunction={handleSort}
              onChangePageFunction={setPaginaAtual}
              paginaAtual={paginaAtual}
              quantidadeDePaginas={totalPages}
              quantidadeDeRegistros={totalElements}
              renderCheckBox={false}
              isLoading={isLoading}
            >
              <RenderRowGestaoAssinatura data={data} refetch={refetch} />
            </Tabela>
          </Grid>
        </Grid>
      </BodyPanel>
    </Panel>
  );
};
